module.exports = __webpack_public_path__ + "static/media/react-native.4e310aee.png";